import convertObjectToFormData from "../utils/convertObjectToFormData";
import config from '../config';

export async function fetchActivities(providerId, branchId,  token, queary) {

    const res = await fetch(`${config.API_URL}/activity?branch_id=${branchId}&q=${queary}`, {
        method: 'get',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*',
            'provider_id': providerId
        },
    });
    if ( res.status !== 200) {
        throw Error('Failed to update');
    }
    const body = await res.json();
    return body;
}

export async function addActivity(providerId, activity, token) {
    let formData = convertObjectToFormData(activity);
    const res = await fetch(`${config.API_URL}/activity`, {
        method: 'post',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*',
            'provider_id': providerId,
        },
        body: formData
    });
    if ( res.status !== 200) {
        throw Error('Failed to update');
    }
    const body = await res.json();
    return body;
}
export async function updateActivity(providerId, activity, token){
    const formData = convertObjectToFormData(activity);
    // console.log(formData)
    const res = await fetch(`${config.API_URL}/activity`, {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*',
            'provider_id': providerId,
            'activity_id': activity._id,
        },
        body: formData,
    })
    if ( res.status !== 200) {
        throw Error('Failed to update');
    }
    const body = await res.json();
    return body;
}

export async function toggleActivityVisibility(providerId, activityId,branchId, token) {
    // We need to convert the JSON object to FormData so that we can attach image
    
    const formData = convertObjectToFormData({ providerId,activityId,branchId })
    console.log(branchId)
    const res = await fetch(`${config.API_URL}/activity/toggle-visibility`, {
        method: 'delete',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*'
        },
        body: formData
    });

    if (res.status !== 200) {
        throw Error('Failed to update');
    }

    const body = await res.json();
    // console.log(body)
    return body;
}

export async function deleteActivity(providerId, activity,token){
    let formData = new FormData();
    formData.append("_id", activity._id)
    const res = await fetch(`${config.API_URL}/activity`, {
        method: 'delete',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*',
            'provider_id': providerId,
            'activity_id': activity._id,
        },
        body: formData
    });

    if ( res.status !== 200) {
        throw Error('Failed to update');
    }
    const body = await res.json();
    return body;
}

export async function validateActivity(providerId, activityId, branchId, isValidated, token){
    const formData = convertObjectToFormData({ providerId,activityId,branchId, isValidated })

    const res = await fetch(`${config.API_URL}/activity/validate-activity`, {
        method: 'put',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*',
        },
        body: formData
    });

    if ( res.status !== 200) {
        throw Error('Failed to update');
    }
    const body = await res.json();
    return body;
}

export async function getAssociatedBranches(template_id,  token){

    const res = await fetch(`${config.API_URL}/branch/template-activities`, {
        method: 'get',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json, text/plain, */*',
            template_id
        },
    });

    if ( res.status !== 200) {
        throw Error('Failed to update');
    }
    const body = await res.json();
    return body;
}
